import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'minutesSeconds',
    standalone: true
})
export class MinutesSecondsPipe implements PipeTransform {
    transform(value: number): string {
        if (value < 0) {
            return '';
        }

        const m = Math.floor(value / 60);
        const s = value % 60;

        return `${m}m ${s < 10 ? '0' : ''}${s}s`;
    }
}